import { createMemberInvoicesPreview } from 'src/shared/services/invoiceService';
import ConsoleHelper from 'src/shared/functions/consoleHelper';
import { CreateMemberInvoicesPreviewRequest } from '../models/createMemberInvoicesPreviewRequest';

type PreviewInvoiceDownloaderProps = {
  dataToPdf: CreateMemberInvoicesPreviewRequest;
  loadingCallback: (isLoading: boolean) => void;
};

export const previewInvoiceDownloader = async (props: PreviewInvoiceDownloaderProps) => {
  const { dataToPdf, loadingCallback } = props;

  try {
    loadingCallback(true);
    const { templateId, payDate } = dataToPdf;
    const result = await createMemberInvoicesPreview(templateId, payDate);
    if (result.data) {
      const blob = new Blob([new Uint8Array(result.data)], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `faktura_${templateId}.pdf`;
      a.click();
      a.remove();
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
      }, 100);
    }
  } catch (e) {
    ConsoleHelper.log(e);
  } finally {
    loadingCallback(false);
  }
};
